import { render } from "./ProductsCategory.vue?vue&type=template&id=4fb5dd53"
import script from "./ProductsCategory.vue?vue&type=script&lang=js"
export * from "./ProductsCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__